import moment from 'moment';
import Avatar from '@components/avatar';
import { Link } from 'react-router-dom';
import { transformNumberCurrency } from '@utils';

const renderClient = (row) => {
  return (
    <Avatar
      initials
      className="me-1"
      color={'light-primary'}
      content={row.user.fullName || ''}
    />
  );
};

const renderType = (row) => {
  const typeColor = {
    m: {
      primary: '#14E4ED',
      secondary: '#E8FEFF',
      text: 'Mes'
    },
    a: {
      primary: '#7139F0',
      secondary: '#EFE8FF',
      text: 'Anual'
    },
    '': {
      primary: '#14E4ED',
      secondary: '#E8FEFF',
      text: 'Mes'
    }
  };

  const Div = () => (
    <div
      style={{
        color: typeColor[row.membershipPeriod].primary,
        background: `${
          typeColor[row.membershipPeriod].secondary
        } 0% 0% no-repeat padding-box`,
        padding: '2.5px 16px',
        borderRadius: '11px',
        fontWeight: 'bold'
      }}
    >
      {typeColor[row.membershipPeriod].text}
    </div>
  );

  return (
    <span className="text-left">
      <Div />
    </span>
  );
};

export const columns = ({}) => [
  {
    name: 'Usuario',
    sortable: true,
    minWidth: '270px',
    sortField: 'fullName',
    selector: (row) => row.user.fullName,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        {renderClient(row)}
        <div className="d-flex flex-column">
          <Link
            to={`/users/view/${row.user._id}`}
            className="user_name text-truncate text-body"
          >
            <span className="fw-bolder">
              {row?.user.fullName || 'No completado'}
            </span>
          </Link>
          <small className="text-truncate text-muted mb-0">
            {row.user.email}
          </small>
        </div>
      </div>
    )
  },
  {
    name: 'MEMBRESÍA',
    sortable: false,
    minWidth: '10px',
    selector: (row) => row.membershipCycle,
    cell: (row) => renderType(row)
  },
  {
    name: 'FECHA PAGO',
    sortable: false,
    minWidth: '180px',
    sortField: 'name',
    selector: (row) => row.createdAt,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">
            {moment(row.createdAt).format('DD/MM/YYYY')}
          </span>
        </div>
      </div>
    )
  },
  {
    name: 'PAGO CLIENTE',
    minWidth: '120px',
    center: true,
    selector: (row) => row.price,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {transformNumberCurrency(row.price, 'currency', 2, 'COP')}
      </span>
    )
  },
  {
    name: 'CUOTA TIENDAS',
    minWidth: '150px',
    center: true,
    selector: (row) => row.commission_percentage,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.commission_percentage * 100}%
      </span>
    )
  },
  {
    name: 'UTILIDAD',
    minWidth: '130px',
    selector: (row) => row.price,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {transformNumberCurrency(
          row.price * row.takehome_percentage,
          'currency',
          2,
          'COP'
        )}
      </span>
    )
  }
];
